import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function startDateBeforeEndDateValidator(startControlName: string, endControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const startControl = formGroup.get(startControlName);
    const endControl = formGroup.get(endControlName);

    // Convert string dates to Date objects for comparison
    const startDate = startControl?.value instanceof Date ? startControl.value : new Date(startControl?.value);
    const endDate = endControl?.value instanceof Date ? endControl.value : new Date(endControl?.value);

    if (startDate && endDate && endDate < startDate) {
      return { startDtBeforeEndDt: true };
    }
   else{
    return null;
   }

  };
}
